import { IProductWarehouseContract } from 'features/inventory/products/types';
import { useTranslation } from 'react-i18next';
import EditUnapprovedMovement from '../form/EditUnapprovedMovementForm';
import { EnhancedDialog } from 'components/enhanced';

interface UnapprovedMovementsUpdateDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  identificators: any;
  movementData: IProductWarehouseContract;
}

export const UnapprovedMovementsUpdateDialog = ({
  isOpen,
  onClose,
  onSubmit,
  identificators,
  movementData
}: UnapprovedMovementsUpdateDialogProps) => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.movements.unapproved';

  return (
    <EnhancedDialog
      title={t(`pages.movements.edit`)}
      subTitle={t(`${translationPrefix}.edit-dialog`, {
        product: movementData?.product,
        warehouse: movementData?.warehouse,
        date: movementData?.date
      })}
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      submitLabel={t(`actions.confirm`)}
      submitButtonProps={{
        type: 'submit',
        form: 'updateMovement'
      }}>
      <EditUnapprovedMovement
        identificators={identificators}
        pwc={movementData}
        onSubmit={onSubmit}
      />
    </EnhancedDialog>
  );
};

export default UnapprovedMovementsUpdateDialog;
